<template>

    <div class="salesLead-notice-container">
        <div class="header-row">
            <span class="heading">{{ $t("lbl_EMPBE_SalesLead_HomeUnread") }}</span>
            <router-link :to="{ path: '/salesLead/all' }" custom v-slot="{ navigate }">
                <a
                    href="javascript:void(0)"
                    @click="isDisabled ? undefined : navigate($event)"
                    class="all-link"
                    v-bind:t_label="'EMP3_SalesLead_Home_Navigate_All_0'"
                >
                    <span class="all-text">{{ $t("lbl_EMPBE_SalesLead_Tab_All") }}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <g clip-path="url(#clip0_sl_all)">
                            <path
                                d="M7.15834 13.825L10.975 10L7.15834 6.175L8.33334 5L13.3333 10L8.33334 15L7.15834 13.825Z"
                                fill="currentColor" />
                        </g>
                        <defs>
                            <clipPath id="clip0_sl_all">
                                <rect width="20" height="20" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                </a>
            </router-link>
        </div>

        <!-- Direct Enquiries -->
        <router-link :to="{ path: '/salesLead/default' }" custom v-slot="{ navigate }">
            <a
                href="javascript:void(0)"
                @click="isDisabled ? undefined : navigate($event)"
                class="button-container"
                v-bind:t_label="'EMP3_SalesLead_Home_Navigate_DirectEnquiries_0'"
            >
                <i>
                    <img
                        :src="'https://cdn.adsalecdn.com/EMP/2-0/SalesLead/Newicon/' + (UnreadEnquiry > 0 ? 'Enquiry_Select.svg' : 'Enquiry.svg')"
                        alt="Direct Enquiries"
                        width="24"
                        height="24"
                    />
                </i>
                <div class="title">
                    <div class="title_Nav">
                        <div class="inner">
                            {{ $t("lbl_EMPBE_SalesLead_DirectEnquiries") }}
                        </div>
                        <div class="FreeTips" v-if="IsFreeBooth">{{ $t('lbl_EMPBE_SalesLeadFreeQuota', {
                            remainingCredit:
                            YearRemainingQuotaEnquiry}) }}</div>
                    </div>
                    <div class="number" v-if="UnreadEnquiry > 0">{{ UnreadEnquiry }}</div>
                    <i>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <g clip-path="url(#clip0_1415_1892)">
                                <path
                                    d="M7.15834 13.825L10.975 10L7.15834 6.175L8.33334 5L13.3333 10L8.33334 15L7.15834 13.825Z"
                                    fill="black" fill-opacity="0.8" />
                            </g>
                            <defs>
                                <clipPath id="clip0_1415_1892">
                                    <rect width="20" height="20" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                    </i>
                </div>

            </a>
        </router-link>
        
        <!-- Name Card entrance -->
        <router-link :to="{ path: '/salesLead/nameCard' }" custom v-slot="{ navigate }">
            <a
                href="javascript:void(0)"
                @click="isDisabled ? undefined : navigate($event)"
                class="button-container"
                v-bind:t_label="'EMP3_SalesLead_Home_Navigate_NameCard_2'"
            >
                <i>
                    <img
                        :src="'https://cdn.adsalecdn.com/EMP/2-0/SalesLead/Newicon/' + (UnreadNameCard > 0 ? 'id_card_small_Select.svg' : 'id_card_small.svg')"
                        alt="Name Card"
                        width="24"
                        height="24"
                    />
                </i>
                <div class="title">
                    <div class="title_Nav">
                        <div class="inner">
                            {{ $t("lbl_EMPBE_SalesLead_NameCard") }}
                        </div>
                        <div class="FreeTips" v-if="IsFreeBooth">{{ $t('lbl_EMPBE_SalesLeadFreeQuota', {
                            remainingCredit:
                            YearRemainingQuotaNameCard}) }}</div>
                    </div>
                    <div class="number" v-if="UnreadNameCard > 0">{{ UnreadNameCard }}</div>
                    <i>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <g clip-path="url(#clip0_1415_1892)">
                                <path
                                    d="M7.15834 13.825L10.975 10L7.15834 6.175L8.33334 5L13.3333 10L8.33334 15L7.15834 13.825Z"
                                    fill="black" fill-opacity="0.8" />
                            </g>
                            <defs>
                                <clipPath id="clip0_1415_1892">
                                    <rect width="20" height="20" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                    </i>
                </div>
            </a>
        </router-link>

        <!-- Like / Follow entrance -->
        <router-link :to="{ path: '/salesLead/likeFollow' }" custom v-slot="{ navigate }">
            <a
                href="javascript:void(0)"
                @click="isDisabled ? undefined : navigate($event)"
                class="button-container"
                v-bind:t_label="'EMP3_SalesLead_Home_Navigate_LikeFollow_3'"
            >
                <i>
                    <img
                        :src="'https://cdn.adsalecdn.com/EMP/2-0/SalesLead/Newicon/' + (UnreadLikeFollow > 0 ? 'favorite_Select.svg' : 'favorite.svg')"
                        alt="Like/Follow"
                        width="24"
                        height="24"
                    />
                </i>
                <div class="title">
                    <div class="title_Nav">
                        <div class="inner">
                            {{ $t("lbl_EMPBE_SalesLead_LikeFollow") }}
                        </div>
                        <div class="FreeTips" v-if="IsFreeBooth">{{ $t('lbl_EMPBE_SalesLeadFreeQuota', {
                            remainingCredit: YearRemainingQuotaLikeFollow
                        }) }}</div>
                    </div>
                    <div class="number" v-if="UnreadLikeFollow > 0">{{ UnreadLikeFollow }}</div>
                    <i>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <g clip-path="url(#clip0_1415_1892)">
                                <path
                                    d="M7.15834 13.825L10.975 10L7.15834 6.175L8.33334 5L13.3333 10L8.33334 15L7.15834 13.825Z"
                                    fill="black" fill-opacity="0.8" />
                            </g>
                            <defs>
                                <clipPath id="clip0_1415_1892">
                                    <rect width="20" height="20" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                    </i>
                </div>
            </a>
        </router-link>

        <router-link :to=" { path: '/salesLead/SourcingRequestMatched' }" custom v-slot="{ navigate }">
            <a
                href="javascript:void(0)"
                @click="isDisabled ? undefined : navigate($event)"
                class="button-container"
                v-bind:t_label="'EMP3_SalesLead_Home_Navigate_SourcingRequestMatched_1'"
            >
                <i>
                    <img
                        :src="'https://cdn.adsalecdn.com/EMP/2-0/SalesLead/Newicon/' + (UnreadSourcingRequests > 0 ? 'Post_match_Select.svg' : 'Post_match.svg')"
                        alt="Sourcing Requests Matched"
                        width="24"
                        height="24"
                    />
                </i>
                <div class="title">
                    <span class="inner">
                        {{ $t("lbl_EMPBE_SalesLead_SourcingMathedTitle") }}
                    </span>
                    <div class="number" v-if="UnreadSourcingRequests > 0">{{ UnreadSourcingRequests }}</div>
                    <i>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <g clip-path="url(#clip0_1415_1892)">
                                <path
                                    d="M7.15834 13.825L10.975 10L7.15834 6.175L8.33334 5L13.3333 10L8.33334 15L7.15834 13.825Z"
                                    fill="black" fill-opacity="0.8" />
                            </g>
                            <defs>
                                <clipPath id="clip0_1415_1892">
                                    <rect width="20" height="20" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                    </i>
                </div>
            </a>
        </router-link>
        <router-link :to="{ path: '/salesLead/SourcingRequestApplied' }" custom v-slot="{ navigate }">
            <a
                href="javascript:void(0)"
                @click="isDisabled ? undefined : navigate($event)"
                class="button-container"
                v-bind:t_label="'EMP3_SalesLead_Home_Navigate_SourcingRequestApplied_1'"
            >
                <i>
                    <img
                        :src="'https://cdn.adsalecdn.com/EMP/2-0/SalesLead/Newicon/' + (UnreadSourcingContactBuyer > 0 ? 'Post_reply_Select.svg' : 'Post_reply.svg')"
                        alt="Your Approved Applications"
                        width="24"
                        height="24"
                    />
                </i>
                <div class="title">
                    <span class="inner">
                        {{ $t("lbl_EMPBE_SalesLead_YourApprovedReplies") }}
                    </span>
                    <div class="number" v-if="UnreadSourcingContactBuyer > 0">{{ UnreadSourcingContactBuyer }}</div>
                    <i>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <g clip-path="url(#clip0_1415_1892)">
                                <path
                                    d="M7.15834 13.825L10.975 10L7.15834 6.175L8.33334 5L13.3333 10L8.33334 15L7.15834 13.825Z"
                                    fill="black" fill-opacity="0.8" />
                            </g>
                            <defs>
                                <clipPath id="clip0_1415_1892">
                                    <rect width="20" height="20" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                    </i>
                </div>

            </a>
        </router-link>

    </div>

</template>
<script>
export default {
    props: {
        UnreadEnquiry: Number,
        UnreadNameCard: {
            type: Number,
            default: 0
        },
        UnreadLikeFollow: {
            type: Number,
            default: 0
        },
        UnreadSourcingRequests: Number,
        UnreadSourcingContactBuyer: Number,
        isDisabled: {
            type: Boolean,
            default: false
        },
        IsFreeBooth: Boolean,
        YearRemainingQuotaEnquiry: Number,
        YearRemainingQuotaNameCard: Number,
        YearRemainingQuotaLikeFollow: Number
    },
}
</script>
<style lang="scss" scoped>
.salesLead-notice-container {
    display: flex;
    padding: 24px;
    flex-direction: column;

    gap: 16px;
    border-radius: 16px;
    background: #FFF;
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.25);

    .header-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        align-self: stretch;
        width: 100%;
        gap: 8px;
    }

    .heading {
        flex: 1 1 auto;
        min-width: 0;
        color: var(--on-surface-80, rgba(0, 0, 0, 0.80));
        font-feature-settings: 'liga' off, 'clig' off;
        font-size: 16px;
        font-family: Roboto;
        font-weight: 700;
        line-height: 130%;
        letter-spacing: 0.15px;
    }

    .all-link {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        flex-shrink: 0;
        text-decoration: none;
        letter-spacing: normal;
        color: var(--on-surface-60, rgba(0, 0, 0, 0.60));

        &:hover,
        &:focus,
        &:active {
            text-decoration: none;
        }

        .all-text {
            margin-top: 1px;
            color: var(--on-surface-60, rgba(0, 0, 0, 0.60));
            font-size: 14px;
            font-family: Inter, Roboto, sans-serif;
            font-weight: 600;
            line-height: 14px;
            text-box-trim: trim-both;
            text-box-edge: cap alphabetic;
            white-space: nowrap;
        }

        svg {
            flex-shrink: 0;
            display: block;
            width: 20px;
            height: 20px;
        }
    }

    .button-container {
        display: flex;
        padding: 8px 16px;
        text-decoration: none;
        justify-content: center;
        align-items: center;
        gap: 12px;
        align-self: stretch;
    .button-container:hover,
    .button-container:focus,
    .button-container:active {
        text-decoration: none;
    }

        border-radius: 8px;
        border: 1px solid var(--outline-10, rgba(0, 0, 0, 0.10));
        background: var(--Surface, #FFF);

        i {
            display: flex;
            width: 24px;
            height: 24px;
            padding: 2.5px 0.036px 2.475px 0px;
            justify-content: center;
            align-items: center;
        }

        .title {
            display: flex;
            align-items: center;
            gap: 4px;
            flex: 1 1 auto;
            min-width: 0;

            .title_Nav
            {
                display: flex;
                align-items: center;
                align-content: center;
                gap: 8px var(--8, 8px);
                flex: 1 1 auto;
                min-width: 0;
                flex-wrap: wrap;
                .inner{
                    display: block;
                    flex: 1 1 auto;
                    min-width: 0;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;

                }
            }
            .inner {
                display: flex;
                flex: 1 1 auto;
                min-width: 0;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                color: var(--on-surface-80, rgba(0, 0, 0, 0.80));

                /* Text/Headline 4 */
                font-size: 14px;
                font-style: normal;
                font-weight: 700;
                line-height: 150%;
                /* 21px */
                letter-spacing: -0.154px;
            }

            .number {
                display: flex;
                min-width: 20px;
                max-width: 42.5px;
                flex-shrink: 0;
                padding: 0px 5px;
                justify-content: center;
                align-items: center;
                border-radius: 125px;
                background: var(--primary-supplier-backend, #7366FF);
                color: var(--M3-sys-light-on-error, #FFF);
                text-align: center;
                font-family: Roboto;
                font-size: 13.75px;
                font-style: normal;
                font-weight: 700;
                line-height: 20px;
                /* 145.455% */
            }

            .FreeTips {
                color: var(--On-Surface-White, #FFF);
                font-feature-settings: 'liga' off, 'clig' off;
                font-size: 12px;
                font-style: normal;
                font-weight: 700;
                line-height: 150%;
                /* 18px */
                display: flex;
                padding: var(--2, 2px) var(--8, 8px);
                align-items: center;
                border-radius: var(--4, 4px);
                background: linear-gradient(90deg, #CB242B 0%, #7128E8 100%), radial-gradient(708.4% 271.29% at 27.34% -79.5%, #BE2A39 0%, #350091 100%), radial-gradient(1543.54% 569.8% at 0% -195.45%, #FF3A3A 0%, #5E0101 100%);
            }

            > i {
                width: 20px;
                height: 20px;
                flex-shrink: 0;
            }
        }

        > i {
            flex-shrink: 0;
        }

    }


}
</style>